import { stringify } from 'qs';

import type {
  ActivitySummaryAsMember,
  FeedbackActivityApiParams,
  FeedbackActivityResponseType,
  ProfileGetResponse,
  ReadActivityPagination,
  ReadHistoriesStatus,
} from '@zoomit/web-kit';

import { Feedback, Profile, UserProfiles } from '../../constants/apis';
import { ApiManager, SHOW_TOAST_HEADER } from '../axios-config';

export const getUserProfileVitrine = async (id: string) => {
  return await ApiManager.get<ActivitySummaryAsMember>(`${UserProfiles}/${id}/vitrine`);
};

export const getUserProfile = async (userId: string) => {
  return await ApiManager.get<ProfileGetResponse>(`${UserProfiles}/${userId}/v2`);
};

export const getReadHistoryStatus = async (articleId: string, token: string) => {
  return await ApiManager.get<ReadHistoriesStatus>(`${Profile}/read-histories/${articleId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const reviewArticle = async (articleId: string, token: string) => {
  return await ApiManager.post(
    `${Profile}/read-histories`,
    { articleId },
    { headers: { Authorization: `Bearer ${token}`, [SHOW_TOAST_HEADER]: false } },
  );
};

export const readArticle = async (articleId: string, minutes: number, token: string) => {
  return await ApiManager.put(
    `${Profile}/read-histories`,
    { articleId, minutes },
    { headers: { Authorization: `Bearer ${token}`, [SHOW_TOAST_HEADER]: false } },
  );
};

export const getReadHistory = async (
  {
    userId,
    status,
    startingDateRangeStart,
    startingDateRangeEnd,
    completingDateRangeStart,
    completingDateRangeEnd,
    pageNumber,
    pageSize,
  }: {
    userId: string;
    status?: string;
    startingDateRangeStart?: string;
    startingDateRangeEnd?: string;
    completingDateRangeStart?: string;
    completingDateRangeEnd?: string;
    pageNumber?: number;
    pageSize?: number;
  },
  token: string,
) => {
  return await ApiManager.get<ReadActivityPagination>(`${Profile}/read-histories`, {
    params: {
      UserId: userId,
      Status: status,
      'StartingDateRange.Start': startingDateRangeStart,
      'StartingDateRange.End': startingDateRangeEnd,
      'CompletingDateRange.Start': completingDateRangeStart,
      'CompletingDateRange.End': completingDateRangeEnd,
      PageNumber: pageNumber,
      PageSize: pageSize,
    },
    paramsSerializer: (params) => {
      return stringify(params);
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getFeedbacksActivity = async ({
  userId,
  sortBy,
  type,
  pageSize = 10,
  pageNumber = 1,
}: FeedbackActivityApiParams) => {
  const feedbackActivityUrl = new URL(`${Feedback}/user/${userId}/activities`);
  const params = new URLSearchParams({
    userId,
    SortBy: sortBy,
    PageSize: `${pageSize}`,
    PageNumber: `${pageNumber}`,
  });
  if (type && type !== 'All') {
    params.append('Type', type);
  } else {
    params.delete('Type');
  }

  feedbackActivityUrl.search = params.toString();

  return ApiManager.get<FeedbackActivityResponseType>(feedbackActivityUrl.toString());
};
